import { COLORS } from '@app/constants';
import { Add } from '@app/ui/iconComponents';
import { FC } from 'react';
import styled, { css } from 'styled-components';
import apx from '@landing/constants/adaptivepx';
import { BreakpointsEnum } from '@app/types';

export type TagTheme = 'primary' | 'secondary' | 'white';

interface Props {

  theme?: TagTheme;
  isLarge?: boolean;
  hasClose?: boolean;
  onClick?: (value: string) => void;
  value: string;

}

const Tag: FC<Props> = ({

  theme = 'primary',
  isLarge = false,
  hasClose = true,
  value,
  onClick,

}) => {

  return (

    <Root $theme = { theme } $isLarge = { isLarge } $hasClose = { hasClose }>

      { value }

      { hasClose && (

        <button onClick = { () => onClick && onClick(value) }>

          <Add color = "inherit" width = { 20 } height = { 20 } />

        </button>

      ) }

    </Root>

  );

};

export default Tag;

interface StyleProps {

  $theme: TagTheme;
  $isLarge: boolean;
  $hasClose: boolean;

}

const Root = styled.div<StyleProps>`

  display: inline-flex;
  align-items: center;

  font-size: ${apx.d(13)};
  font-weight: 500;
  line-height: ${apx.d(20)};

  @media (max-width: ${BreakpointsEnum.sm}px) {

    font-size: ${apx.m(13)};
    line-height: ${apx.m(20)};

  }

  ${({ $theme }) => {

    switch ( $theme ) {

      case 'secondary':

        return css`

          --bg-color: ${COLORS.grayscale100};
          --color: ${COLORS.black};

        `;

      case 'white':

        return css`

          --bg-color: ${COLORS.white};
          --color: ${COLORS.secondary400};

        `;

      default:

        return css`

          --bg-color: ${COLORS.secondary300};
          --color: ${COLORS.black};

        `;

    }

  }};

  background-color: var(--bg-color);
  color: var(--color);

  & > button {

    display: flex;

  }

  & svg {

    stroke: var(--color);
    transform: rotate(45deg);
    margin-left: ${apx.d(5)};

    @media (max-width: ${BreakpointsEnum.sm}px) {

      margin-left: ${apx.m(5)};

    }


  }

  ${({ $isLarge, $hasClose }) =>
    $isLarge
      ? css`
          padding: ${$hasClose ? `${apx.d(8)} ${apx.d(11)} ${apx.d(8)} ${apx.d(16)}` : `${apx.d(8)} ${apx.d(16)}`};
          border-radius: ${apx.d(20)};
        `
      : css`
          padding: ${$hasClose ? `${apx.d(2)} ${apx.d(2)} ${apx.d(2)} ${apx.d(7)}` : `${apx.d(2)} ${apx.d(7)}`};
          border-radius: ${apx.d(24)};
        `};
`;
